import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';
import { Location } from '@angular/common';
import { Observable, of, timeout, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { FactoryService } from '@services/common/factory.service';
import { ComRouteService } from '@services/common/com-route.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private location: Location,
        private factorySer: FactoryService,
        private comRoute: ComRouteService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        req = req.clone({
            setHeaders: {
                'Accept-Language': this.factorySer.language
            }
        });
        if(req.method === 'POST'){
            req.body['channelCode'] = this.factorySer.getChannel();
            req.body['businessCode'] = this.factorySer.getBusiness();
            req.body['entryCode'] = this.factorySer.getEntryCode();
        }

        return next.handle(req).pipe(
            timeout(60000),
            mergeMap((res: any) => {
                if (res instanceof HttpResponse) {
                    if (res?.status === 200 && res?.body?.code === '10040' ) { // 10040: login overdue
                        this.navigateLogin();
                    }
                    return of(res);
                }
                return of(res);
            }),
            catchError((res: HttpErrorResponse) => {
                return throwError(res);
            })
        );
    }

    private navigateLogin() {
        const path = this.location.path();
        if (path.indexOf('/member/landing') > 0) {
            return;
        } else { 
            this.comRoute.route('login');
        }
    }

}